export const items = [
  [
      {
      name: 'Platform Overview',
      icon: '/Dashboards.svg',
      link: '/platform/overview/'
    },
      {
      name: 'Cyra, your AI Assistant',
      icon: '/Automation.svg',
      link: '/platform/ai/'
    },
       {
      name: 'Integration Marketplace',
      icon: '/Integrations.svg',
      link: '/platform/integration-marketplace/'
    }
  ],
  [
    {
      name: 'Security',
      icon: '',
      link: 'null'
    },
    {
      name: 'Endpoint Security',
      icon: '/EndpointSecurity.svg',
      link: '/platform/endpoint-security/'
    },{
      name:'XDR',
      icon:'/XDR.svg',
      link:'/platform/xdr/'
    },
    {
      name: 'Identity Security',
      icon: '/UserActivity.svg',
      link: '/platform/identity-security/'
    },
    {
      name: 'Exposure Management',
      icon: '/IncidentResponse.svg',
      link: '/platform/exposure-management/'
    },
    {
      name: 'Email Security',
      icon: '/Reports.svg',
      link: '/platform/email-security/'
    },
    {
      name: 'Next-Gen SIEM',
      icon: '/CloudSIEM.svg',
      link: '/platform/next-gen-siem/'
    },{
      name: 'SOAR',
      icon: '/SOAR.svg',
      link: '/platform/soar/'
    },
    {
      name: 'Threat Hunting',
      icon: '/ThreatHunting.svg',
      link: '/platform/threat-hunting/'
    },
    {
      name: 'Data Loss Prevention',
      icon: '/DataLoss.svg',
      link: '/platform/data-loss-prevention/'
    },{
      name: 'Honeypot',
      icon: '/Honeypot.svg',
      link: '/platform/honeypot/'
    }
  ],
  [
    {
      name: 'Operations',
      icon: '',
      link: 'null'
    },
    {
      name: 'Log Management',
      icon: '/LogManagement.svg',
      link: '/platform/log-management/'
    },
    {
      name: 'Endpoint Management',
      icon: '/ManagedXDR.svg',
      link: '/platform/endpoint-management/'
    },
    {
      name: 'Remote Access',
      icon: '/RemoteAccess.svg',
      link: '/platform/remote-access/'
    },
    {
      name: 'Cloud File Storage',
      icon: '/CloudUpload.svg',
      link: '/platform/cloud-file-storage/'
    },
    {
      name: 'Compliance Tracking',
      icon: '/ComplianceTracking.svg',
      link: '/platform/compliance-tracking/'
    }
  ],[
    {
      name: 'Observability',
      icon: '',
      link: 'null'
    },
    {
      name: 'Endpoint Monitoring',
      icon: '/ManagedXDR.svg',
      link: '/platform/endpoint/'
    },
    {
      name: 'Network',
      icon: '/NetworkMonitoring.svg',
      link: '/platform/network/'
    },
    {
      name: 'Cloud',
      icon: '/CloudSIEM.svg',
      link: '/platform/cloud/'
    },
    {
      name: 'User Activity',
      icon: '/UserActivity.svg',
      link: '/platform/user-activity/'
    },
    {
      name: 'Application',
      icon: '/ApplicationMonitoring.svg',
      link: '/platform/application/'
    },
  ]
];

export const label = 'Platform';
